<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      商户设置>人员配置
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">

      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <!-- 左边查询区 -->
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">账号名称：</label>
            <el-input v-model="selectForm.no" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">角色：</label>
            <el-select v-model="selectForm.roleId" clearable filterable size="mini" style="float: left;">
              <el-option v-for="item in merchantRoleList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageMyMerchantUser(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>
          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">

            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary" @click="insertShow()">
              <a-icon type="plus-circle"/>
              新增用户
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>

            <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                          @confirm="deleteMerchantUserBatch()">
              <el-button size="mini" style="background-color: #e32e2e1a;color:#e32e2e;border:1px solid #e32e2e;"
                         type="primary">
                <a-icon type="minus-circle"/>
                批量删除
              </el-button>
            </a-popconfirm>
          </div>


        </div>

        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <el-table :data="tableData" align="center" height="600" size="mini"
                    style="color: #555;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="账号" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.userVO ? scope.row.userVO.no : "" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="名称" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.userVO ? scope.row.userVO.name : "" }}
              </template>
            </el-table-column>

            <el-table-column align="center" label="角色" min-width="20%">
              <template slot-scope="scope">
                <el-tag v-for="role in scope.row.authRoleVOList" v-if="scope.row.authRoleVOList"
                        style="margin-right: 10px" type="success">{{ role.name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="创建时间" min-width="20%">
              <template slot-scope="scope">
                {{ parseDate(scope.row.userVO ? scope.row.userVO.createDate : "") }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="20%">
              <template slot-scope="scope">
                <span style="font-size:0.9rem;color:#25AD7F;cursor: pointer;"
                      @click="detailShow(scope.row)">详情</span>
                <span style="margin:0px 5px">|</span>
                <span style="font-size:0.9rem;cursor: pointer;color: #409EFF"
                      @click="updateShow(scope.row)">修改</span>
                <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                              @confirm="deleteMerchantUser(scope.row)">
                  <span style="margin:0px 5px">|</span>
                  <span style="font-size:0.9rem;color:#e32e2e;cursor: pointer;">删除</span>
                </a-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <el-dialog :before-close="insertCancel" :visible.sync="insertDialog" title="新增用户" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">


          <el-form-item>
            <template slot="label">
              账号 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.no" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="或手机号码" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item>
            <template slot="label">
              密码 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.loginPassword" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入密码" show-password
                      size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item>
            <template slot="label">
              确认密码 <span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.loginPasswordConfirm" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请再次输入密码" show-password
                      size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              名称<span style="color: red">*</span>
            </template>
            <el-input v-model="insertForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              角色<span style="color: red">*</span>
            </template>
            <el-checkbox-group v-model="insertForm.roleIdList" @change="insertRoleChange">
              <el-checkbox v-for="role in merchantRoleList" :key="role.id" :label="role.id">{{ role.name }}
              </el-checkbox>
            </el-checkbox-group>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="insertSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="insertCancel">取消</el-button>
      </div>
    </el-dialog>


    <!-- 详情 -->
    <el-dialog :before-close="detailCancel" :visible.sync="detailDialog" title="人员详情" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="detailInfo"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">
          <el-descriptions :column=2 :title="detailInfo.userVO?detailInfo.userVO.name:''">
            <el-descriptions-item label="账号">{{ detailInfo.userVO ? detailInfo.userVO.no : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="名称">{{ detailInfo.userVO ? detailInfo.userVO.name : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="创建时间">{{
                parseDate(detailInfo.userVO ? detailInfo.userVO.createDate : "")
              }}
            </el-descriptions-item>
            <el-descriptions-item label="角色">
              <el-tag v-for="role in detailInfo.authRoleVOList" v-if="detailInfo.authRoleVOList"
                      style="margin-right: 10px" type="success">{{ role.name }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="detailCancel">关闭</el-button>
      </div>
    </el-dialog>


    <!-- 新增 -->
    <el-dialog :before-close="updateCancel" :visible.sync="updateDialog" title="修改用户" width="40%">
      <div style="width: 100%;float: left">
        <el-form label-width="15%" style="width:100%;float:left;">


          <el-form-item>
            <template slot="label">
              账号 <span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.no" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="或手机号码" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item>
            <template slot="label">
              密码 <span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.loginPassword" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入密码" show-password
                      size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item>
            <template slot="label">
              确认密码 <span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.loginPasswordConfirm" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请再次输入密码" show-password
                      size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              名称<span style="color: red">*</span>
            </template>
            <el-input v-model="updateForm.name" oninput="if(value.length>35)value=value.slice(0,35)" size="mini"
                      style="width:85%;float: left;"/>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>

          <el-form-item label="">
            <template slot="label">
              角色<span style="color: red">*</span>
            </template>
            <el-checkbox-group v-model="updateForm.roleIdList" @change="updateRoleChange">
              <el-checkbox v-for="role in merchantRoleList" :key="role.id" :label="role.id">{{ role.name }}
              </el-checkbox>
            </el-checkbox-group>
            <div style="width: 15%;float: left;text-indent: 5px;"></div>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-submit" @click="updateSubmit">提交</el-button>
        <el-button class="dialog-footer-cancel" @click="updateCancel">取消</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>


import {listMerchantRoleApi} from "@/router/api/auth/role-api";

import {
  deleteMerchantUserApi,
  pageMyMerchantUserApi,
  registerMerchantUserApi,
  updateMerchantUserApi
} from "@/router/api/merchant/merchant-api";


import * as XLSX from "xlsx";
import {saveAs} from "file-saver";


export default {
  name: "MerchantUserSetting",
  data() {
    return {
      merchantRoleList: [],
      //查询
      tableData: [],
      selectForm: {
        no: null,
        roleId: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      selectTableRow: [],
      tableLoading:false,

      //新增
      insertDialog: false,
      insertForm: {
        platform: "web_admin",
        no: null,
        loginPassword: null,
        loginPasswordConfirm: null,
        name: null,
        roleIdList: []
      },

      //  详情
      detailDialog: false,
      detailInfo: null,

      //修改
      updateDialog: false,
      updateForm: {
        userId: null,
        merchantId: null,
        no: null,
        loginPassword: null,
        loginPasswordConfirm: null,
        name: null,
        roleIdList: []
      },


    };
  },

  mounted() {
    this.load();


  },

  methods: {

    load() {
      this.pageMyMerchantUser();

      listMerchantRoleApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.merchantRoleList = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

    },

    // 查询
    selectReset() {
      this.selectForm = {
        merchantNo: null,
        companyName: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      };
      this.pageMyMerchantUser(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageMyMerchantUser(true);
    },

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },


    pageMyMerchantUser(showMessage) {
      this.tableLoading = true;
      pageMyMerchantUserApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }

      const data = [
        ["账号", "名称", "角色", "创建时间"]
      ];

      //添加数据

      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell1 = row.userVO ? row.userVO.no : "";
          let cell2 = row.userVO ? row.userVO.name : "";
          let cell4 = "";
          if (row.authRoleVOList && row.authRoleVOList.length > 0) {
            for (let j = 0; j < row.authRoleVOList.length; j++) {
              let role = row.authRoleVOList[j];
              if (role) {
                cell4 += role.name + "，";
              }
            }
          }
          let cell5 = row.userVO ? new Date(row.userVO.createDate).toLocaleString() : "";
          data.push([cell1, cell2, cell4, cell5]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "商户用户-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },

    // 查询 end

    // 新增 begin

    insertShow() {
      this.insertDialog = true;
    },

    insertCancel() {
      this.insertDialog = false;
      this.insertForm = {
        platform: "web_admin",
        no: null,
        name: null,
        roleIdList: []
      };

    },

    insertRoleChange(value) {
      this.insertForm.roleIdList = value;
    },

    insertSubmit() {

      if (!this.insertForm.loginPassword) {
        this.showMessage("请输入密码", "error");
        return false;
      }
      if (!this.insertForm.loginPasswordConfirm) {
        this.showMessage("请输入确认密码", "error");
        return false;
      }

      if (this.insertForm.loginPassword != this.insertForm.loginPasswordConfirm) {
        this.showMessage("两次密码不一致", "error");
        return false;
      }

      if (!this.insertForm.no) {
        this.showMessage("请填写账号", "error");
        return false;
      }
      if (!this.insertForm.name) {
        this.showMessage("请填写名称", "error");
        return false;
      }

      registerMerchantUserApi(this.insertForm, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.insertCancel();
              this.pageMyMerchantUser();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

    },

    // 新增 end

    // 详情 begin
    detailShow(data) {
      this.detailInfo = data;
      this.detailDialog = true;
    },

    detailCancel() {
      this.detailDialog = false;
      this.detailInfo = null;
    },
    // 详情 end

    // 删除 begin
    deleteMerchantUser(item) {
      if (!item) {
        this.showMessage("请选择需要解除绑定的用户", "warning");
        return false;
      }
      let params = [
        {
          "userId": item.userId,
          "merchantId": item.merchantId
        }
      ];
      deleteMerchantUserApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageMyMerchantUser();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });


    },

    deleteMerchantUserBatch() {

      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要需要解除绑定的用户", "warning");
        return false;
      }

      let params = [];
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          params.push({
            "userId": row.userId,
            "merchantId": row.merchantId
          });
        }
      }

      deleteMerchantUserApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageMyMerchantUser();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });


    },

    // 删除 end

    // 修改 begin

    updateShow(data) {
      this.updateDialog = true;
      let roleIdList = [];
      if (data && data.authRoleVOList.length > 0) {
        for (let i = 0; i < data.authRoleVOList.length; i++) {
          let role = data.authRoleVOList[i];
          if (role) {
            roleIdList.push(role.id);
          }
        }
      }
      this.updateForm = {
        userId: data.userVO.id,
        merchantId: data.merchantId,
        no: data.userVO.no,
        name: data.userVO.name,
        roleIdList: roleIdList
      };
    },

    updateRoleChange(value) {
      this.updateForm.roleIdList = value;
    },

    updateCancel() {
      this.updateDialog = false;
      this.updateForm = {
        userId: null,
        merchantId: null,
        no: null,
        name: null,
        roleIdList: []
      };
    },

    updateSubmit() {

      if (!this.updateForm.no) {
        this.showMessage("请填写账号", "error");
        return false;
      }
      if (!this.updateForm.name) {
        this.showMessage("请填写名称", "error");
        return false;
      }

      if (this.updateForm.loginPassword) {
        if (!this.updateForm.loginPasswordConfirm) {
          this.showMessage("请输入确认密码", "error");
          return false;
        }
        if (this.updateForm.loginPassword != this.updateForm.loginPasswordConfirm) {
          this.showMessage("两次密码不一致", "error");
          return false;
        }
      }

      let params = this.updateForm;
      updateMerchantUserApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.updateCancel();
              this.pageMyMerchantUser();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

    },

    // 修改 end

    // 工具

    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }

  }

};

</script>


<style scoped>

.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}


/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}

</style>
